export default __webpack_public_path__ + "static/media/mailicon.91d7faf6.svg";